// dependencies
import { CreateProcess } from "redux-process";

// utils
import objectToQueryString from "Utils/objectToQueryString";

export const GetRequestReport = CreateProcess({
	method: "GET",
	name: "Get Request Report",
	type: "REPORTS:GetRequests",

	request: (props) => {
		const { params } = props;
		const { date, timeZoneOffsetMilliseconds } = params;

		const queryString = objectToQueryString({ date, timeZoneOffsetMilliseconds });

		return {
			url: `/production/reports/requests/?${queryString}`,
		};
	},

	success: (response) => {
		let requests = response.data.map((request) => {
			return {
				...request,
				unixTime: request.startTime,
				startTime: new Date(request.startTime * 1000),
				maxResponseTime: parseFloat((request.maxResponseTime * 1000).toFixed(2)),
				meanResponseTime: parseFloat((request.meanResponseTime * 1000).toFixed(2)),
			};
		});

		if (requests.length < 288) {
			const emptyRequests = Array.from({ length: 288 - requests.length });

			requests = [...requests, ...emptyRequests];
		}

		return {
			requests: requests,
		};
	},
});

export const GetFlameChart = CreateProcess({
	method: "GET",
	name: "Get Request Flame Chart",
	type: "REPORTS:GetFlameChart",

	request: (props) => {
		const { params } = props;
		const { requestID } = params;

		return {
			url: `/production/reports/flame-chart/${requestID}`,
		};
	},

	success: (response) => {
		console.log(response);

		return {
			...response.data,
		};
	},
});
